/* @flow */

import { combineReducers } from 'redux';

import appAllBraindatesReducer from './appAllBraindateReducer';

// $FlowIssue
const appBraindatesReducer = combineReducers({
  all: appAllBraindatesReducer,
});

export default appBraindatesReducer;
